var INFOBOX_APPEARANCES = ['success', 'warning', 'danger'];

export { INFOBOX_APPEARANCES };
